import PropTypes from 'prop-types';

import ErrorBoundary from 'components/ErrorBoundary';
import GenericError from 'components/GenericError';

import placeholder from 'lib/placeholder';

import List from './CommentsList';

const CommentsList = ({
  aliasId = null,
  authors,
  authorCount,
  className,
  isOfferCommentsAllowed,
  offerCommentsCount,
  offerId,
  offerInstructions,
  offerPublished,
  offerStatusName,
  serverComments,
  userId,
  userName,
  userSpecialtyName,
  userUsername,
}) => (
  <ErrorBoundary
    fallback={
      <GenericError message={placeholder('errors.couldNotLoadComments')} />
    }
  >
    <List
      aliasId={aliasId}
      authorCount={authorCount}
      authors={authors}
      className={className}
      initialComments={serverComments}
      isReadOnly={!isOfferCommentsAllowed}
      offerCommentsCount={offerCommentsCount}
      offerId={offerId}
      offerInstructions={offerInstructions}
      offerPublished={offerPublished}
      offerStatusName={offerStatusName}
      userId={userId}
      userName={userName}
      userSpecialtyName={userSpecialtyName}
      userUsername={userUsername}
    />
  </ErrorBoundary>
);

CommentsList.displayName = 'DynamicallyLoadedOfferCommentsWithRef';

CommentsList.propTypes = {
  aliasId: PropTypes.number,
  authors: PropTypes.arrayOf(PropTypes.shape()),
  authorCount: PropTypes.number,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  isOfferCommentsAllowed: PropTypes.bool.isRequired,
  offerCommentsCount: PropTypes.number.isRequired,
  offerId: PropTypes.number.isRequired,
  offerInstructions: PropTypes.string,
  offerPublished: PropTypes.string,
  offerStatusName: PropTypes.string.isRequired,
  serverComments: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  userId: PropTypes.number,
  userName: PropTypes.string,
  userSpecialtyName: PropTypes.string,
  userUsername: PropTypes.string,
};

export default CommentsList;
